// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3E7Jr","header":"PatientQuestionnaire_header__2zK6o","info":"PatientQuestionnaire_info__2pfLW"};